import _sfc_main from "./CobrandLimitedTimeOffer2.mjs";
/* empty css                          */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const CobrandLimitedTimeOffer = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-3ad1bc92"]]);
export {
  CobrandLimitedTimeOffer as default
};
//# sourceMappingURL=CobrandLimitedTimeOffer.mjs.map
